import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=22e71dec&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e71dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e71dec')) {
      api.createRecord('22e71dec', component.options)
    } else {
      api.reload('22e71dec', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=22e71dec&scoped=true&", function () {
      api.rerender('22e71dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8EuT8dgEfhFju/JS/comp/Accordion.vue"
export default component.exports